<template>
  <div class="certificate-upload">
    <div v-if="displayUrl" class="preview">
      <img v-if="isImage" :src="displayUrl" alt="证书预览" class="preview-image">
      <div v-else class="preview-file">
        <i class="el-icon-document" />
        <span>{{ fileName || '证书文件' }}</span>
        <el-button type="text" size="mini" @click="openFile">预览</el-button>
      </div>
      <div class="preview-actions">
        <el-upload
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          :accept="accept"
          :disabled="uploading"
          :on-change="handleChange"
        >
          <el-button size="mini" :loading="uploading">更换</el-button>
        </el-upload>
        <el-button size="mini" type="text" class="danger" @click="clear">移除</el-button>
      </div>
    </div>
    <el-upload
      v-else
      action="#"
      :auto-upload="false"
      :show-file-list="false"
      :accept="accept"
      :disabled="uploading"
      :on-change="handleChange"
    >
      <el-button size="small" type="primary" :loading="uploading">{{ buttonText }}</el-button>
    </el-upload>
    <div v-if="hint" class="hint">{{ hint }}</div>
  </div>
</template>

<script>
import { uploadFile } from '@/api/upload'
import { normalizeFileUrl, resolveFileUrl } from '@/utils/fileUrl'

const MAX_SIZE = 10 * 1024 * 1024
const IMAGE_TYPES = /^image\//
const ACCEPT = 'image/*,.pdf,application/pdf'

export default {
  name: 'CertificateUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    bizType: {
      type: String,
      default: 'copyright'
    },
    buttonText: {
      type: String,
      default: '上传证书'
    },
    hint: {
      type: String,
      default: '支持 JPG/PNG/PDF，不超过 10MB'
    }
  },
  data() {
    return {
      uploading: false,
      fileName: '',
      accept: ACCEPT
    }
  },
  computed: {
    displayUrl() {
      return resolveFileUrl(this.value)
    },
    isImage() {
      if (!this.value) return false
      return /\.(png|jpe?g|gif|webp)$/i.test(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(url) {
        if (!url) {
          this.fileName = ''
          return
        }
        const name = url.split('/').pop()
        this.fileName = name || '证书文件'
      }
    }
  },
  methods: {
    openFile() {
      if (this.displayUrl) window.open(this.displayUrl, '_blank')
    },
    clear() {
      this.fileName = ''
      this.$emit('input', '')
    },
    async handleChange(fileObj) {
      const file = fileObj && fileObj.raw
      if (!file) return
      const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name)
      if (!IMAGE_TYPES.test(file.type) && !isPdf) {
        this.$message.warning('请上传图片或 PDF 文件')
        return
      }
      if (file.size > MAX_SIZE) {
        this.$message.warning('文件大小不能超过 10MB')
        return
      }
      this.uploading = true
      try {
        const result = await uploadFile(file, this.bizType, { useAdmin: true })
        this.fileName = file.name
        this.$emit('input', normalizeFileUrl(result.url))
        this.$message.success('上传成功')
      } catch (e) {
        // 错误由 request 拦截器统一弹框
      } finally {
        this.uploading = false
      }
    }
  }
}
</script>

<style scoped>
.certificate-upload {
  line-height: 1.4;
}
.preview {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.preview-image {
  max-width: 240px;
  max-height: 160px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  background: #f5f7fa;
}
.preview-file {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #f8fafc;
  color: #475569;
  font-size: 13px;
}
.preview-file i {
  font-size: 20px;
  color: #409eff;
}
.preview-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.hint {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.danger {
  color: #f56c6c;
}
</style>
